import { useState } from 'react'

import Box from '@mui/material/Box'

import type { Projectbetrokkene as ProjectbetrokkeneType } from '@models/Projectbetrokkene'

import type { AuthenticatedUser } from '../../auth/types/AuthenticatedUser'
import {
  groupProjectbetrokkenenByVerantwoordelijkeAndGebied,
  isProjectbetrokkeneWijzigbaar,
} from '../util/projectbetrokkene-util'

import { ProjectbetrokkenenCard } from './ProjectbetrokkenenCard'
import { CreateBetrokkene } from './dialogs/CreateBetrokkene'
import { DeleteBetrokkene } from './dialogs/DeleteBetrokkene'
import { EditDisciplines } from './dialogs/EditDisciplines'

export { Projectbetrokkenen }

type Props = {
  user: AuthenticatedUser
  projectType: ProjectbetrokkeneType['projectType']
  projectbetrokkenen: ProjectbetrokkeneType[]
}

const Projectbetrokkenen = ({
  user,
  projectType,
  projectbetrokkenen,
}: Props) => {
  const { canViewBeheer, canCreateProjectbetrokkene } = user
  const [selected, setSelected] = useState<ProjectbetrokkeneType[] | null>(null)
  const [teVerwijderen, setTeVerwijderen] =
    useState<ProjectbetrokkeneType | null>(null)
  const [teWijzigen, setTeWijzigen] = useState<ProjectbetrokkeneType | null>(
    null,
  )

  const groupedProjectbetrokkenen =
    groupProjectbetrokkenenByVerantwoordelijkeAndGebied(projectbetrokkenen)

  const mayEditBetrokkenen =
    canViewBeheer &&
    canCreateProjectbetrokkene &&
    isProjectbetrokkeneWijzigbaar(projectType)

  return (
    <>
      {Object.keys(groupedProjectbetrokkenen).length > 0 && (
        <Box>
          {Object.entries(groupedProjectbetrokkenen).map(
            ([verantwoordelijkeAndGebied, projectbetrokkenen], index) => (
              <ProjectbetrokkenenCard
                key={verantwoordelijkeAndGebied}
                expanded={index === 0}
                projectbetrokkenen={projectbetrokkenen}
                showCreateBetrokkene={mayEditBetrokkenen}
                onClickCreateBetrokkene={() => setSelected(projectbetrokkenen)}
                showDeleteBetrokkene={mayEditBetrokkenen}
                onClickDeleteBetrokkene={setTeVerwijderen}
                showEditDisciplines={mayEditBetrokkenen}
                onClickEditDisciplines={setTeWijzigen}
              />
            ),
          )}
        </Box>
      )}

      {selected && (
        <CreateBetrokkene
          projectbetrokkenen={selected}
          projectType={projectType}
          onClose={() => setSelected(null)}
        />
      )}

      {teWijzigen?._id && (
        <EditDisciplines
          projectbetrokkene={{ ...teWijzigen, _id: teWijzigen._id }}
          onClose={() => setTeWijzigen(null)}
        />
      )}

      {teVerwijderen && (
        <DeleteBetrokkene
          projectbetrokkene={teVerwijderen}
          onClose={() => setTeVerwijderen(null)}
        />
      )}
    </>
  )
}
